export const reportReasons = {
  SPAM: 'Spam',
  BULLYING: 'Bullying or harassment',
  HATE_SPEECH: 'Hate speech or symbols',
  ILLEGAL_SALE: 'Sale of illegal goods',
  NUDITY: 'Nudity or pornography',
  VIOLENCE: 'Violence or self-harm',
  OTHER: 'Other',
}
